import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Validator from '@/utils/Validator'

export default {
  name: 'ServiceDeliveryTermDetail',
  components: {
    Loading
  },
  metaInfo () {
    let title = this.categoryName + '管理 | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  props: {
    serviceId: String,
    deliveryTypeId: String
  },
  data () {
    return {
      loading: true,
      processing: false,
      
      // テーブルオプション
      tableColumns: [
        'serviceDeliveryPeriodId',
        'deliveryFrequencyKbn',
        'deliveryToKbn',
        'deliveryPeriodDays',
        'deliveryStartTime',
        'deliveryEndTime',
        'modifyButton',
        'deleteButton'
      ],
      tableData: [],
      tableOptions: {
        headings: {
          serviceDeliveryPeriodId: '配信期間ID',
          deliveryFrequencyKbn: '配信頻度',
          deliveryToKbn: '配信先',
          deliveryPeriodDays: '配信期間',
          deliveryStartTime: '配信開始時刻',
          deliveryEndTime: '配信終了時刻',
          modifyButton: '',
          deleteButton: ''
        },
        columnsClasses: {
          serviceDeliveryPeriodId: '',
          deliveryFrequencyKbn: '',
          deliveryToKbn: '',
          deliveryPeriodDays: '',
          deliveryStartTime: '',
          deliveryEndTime: '',
          modifyButton: 'wp-5 has-button',
          deleteButton: 'wp-5 has-button'
        },
        sortable: [
          'serviceDeliveryPeriodId',
          'deliveryFrequencyKbn',
          'deliveryToKbn',
          'deliveryPeriodDays',
          'deliveryStartTime',
          'deliveryEndTime'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts('配信期間'),
        // perPage: Constants.TableOptions.perPage.view,
        perPage: Constants.TablePerPageInitial,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial,

      // 変更
      modifyTargetId: null,
      deleteTargetId: null,
    }
  },
  // beforeMount () {
  //   if (this.getPermission('Member')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    this.init()
    this.initRegister()
  },
  computed: {
    ...mapState({
      categoryName: state => state.serviceDeliveryTermDetail.categoryName,
      deliveryTypeModel: state => state.serviceDeliveryTermDetail.deliveryTypeModel,
      deliveryPeriodModel: state => state.serviceDeliveryTermDetail.deliveryPeriodModel,

      // form
      values: state => state.serviceDeliveryTermDetail.values,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      permittedView: 'permission/permittedView',
      isSmartPhone: 'core/isSmartPhone',
      isRegister: 'serviceDeliveryTermDetail/isRegister',
      isModify: 'serviceDeliveryTermDetail/isModify'
    }),

    formButtonLabel () {
      return this.isRegister ? '登録' : '変更'
    },

    // result
    resultDeliveryTypeName () {
      return this.deliveryTypeModel.deliveryTypeName
    },
    resultDeliveryType () {
      return this.deliveryTypeModel.deliveryType
    },
    resultDeliveryPriority () {
      return Utility.getConstantsLabel(['Mst', 'DeliveryPriorityKbn'], Number(this.deliveryTypeModel.deliveryPriority))
    },

    // list
    deliveryFrequencyList () {
      return Constants.Service.DeleiveryFrequency
    },
    deliveryTargetList () {
      return Constants.Service.DeliveryTarget
    },
    hoursList () {
      return Constants.Hours
    },
    minutesList () {
      return Constants.Minutes
    },
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },

    // input
    inpDeliveryFrequency: {
      get () {
        return this.values.inpDeliveryFrequency
      },
      set (value) {
        this.setInputValue({
          key: 'inpDeliveryFrequency',
          value: value
        })
      }
    },
    inpDeliveryTarget: {
      get () {
        return this.values.inpDeliveryTarget
      },
      set (value) {
        this.setInputValue({
          key: 'inpDeliveryTarget',
          value: value
        })
      }
    },
    inpDeliveryTerm: {
      get () {
        return this.values.inpDeliveryTerm
      },
      set (value) {
        this.setInputValue({
          key: 'inpDeliveryTerm',
          value: value
        })
      }
    },
    inpDeliveryStartHour: {
      get () {
        return this.values.inpDeliveryStartHour
      },
      set (value) {
        this.setInputValue({
          key: 'inpDeliveryStartHour',
          value: value
        })
      }
    },
    inpDeliveryStartMinute: {
      get () {
        return this.values.inpDeliveryStartMinute
      },
      set (value) {
        this.setInputValue({
          key: 'inpDeliveryStartMinute',
          value: value
        })
      }
    },
    inpDeliveryEndHour: {
      get () {
        return this.values.inpDeliveryEndHour
      },
      set (value) {
        this.setInputValue({
          key: 'inpDeliveryEndHour',
          value: value
        })
      }
    },
    inpDeliveryEndMinute: {
      get () {
        return this.values.inpDeliveryEndMinute
      },
      set (value) {
        this.setInputValue({
          key: 'inpDeliveryEndMinute',
          value: value
        })
      }
    },

    // validate
    inpDeliveryFrequencyIsValid () {
      return Validator.validText(this.inpDeliveryFrequency)
    },
    inpDeliveryTargetIsValid () {
      return Validator.validText(this.inpDeliveryTarget)
    },
    inpDeliveryTermIsValid () {
      return Validator.validText(this.inpDeliveryTerm)
    },
    inpDeliveryEndTimeIsValid () {
      return Validator.validText(this.inpDeliveryEndHour) &&
        Validator.validText(this.inpDeliveryEndMinute)
    },
    formIsValid () {
      return this.inpDeliveryFrequencyIsValid &&
        this.inpDeliveryTargetIsValid &&
        this.inpDeliveryTermIsValid &&
        this.inpDeliveryEndTimeIsValid
    },
    disablePostButton () {
      return !this.formIsValid
    }
  },
  watch: {
    confirmAccepted: function (to) {
      console.log('confirmKey : ', this.confirmKey)
      // 登録
      if (this.confirmKey === 'register') {
        if (to) this.postData()
      }
      // 削除
      if (this.confirmKey === 'delete') {
        if (to) this.deleteData()
      }
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'serviceDeliveryTermDetail/loadModel',
      initRegister: 'serviceDeliveryTermDetail/initRegister',
      initModify: 'serviceDeliveryTermDetail/initModify',
    }),
    ...mapMutations({
      setInputValue: 'serviceDeliveryTermDetail/setInputValue',
    }),

    init () {
      this.loading = true

      //
      let deliveryTypeParams = {
        serviceUuid: this.serviceId,
        serviceDeliveryTypeUuid: this.deliveryTypeId
      }

      // データ読出し
      this.loadModel({
        deliveryTypeParams: deliveryTypeParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.deliveryPeriodModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    // ファイル登録
    confirmData() {
      const id = Utility.getObjectArrayValue(this.deliveryPeriodModel, 'serviceDeliveryPeriodUUid', this.modifyTargetId, 'serviceDeliveryPeriodId')
      this.showConfirm({
        key: 'register',
        title: '',
        body: this.isRegister ?
          'この内容で' + this.categoryName + 'を登録しますか？' :
          '「Id : ' + id + '」の' + this.categoryName + '情報を変更しますか？'
      })
    },
    postData () {
      this.processing = true

      //
      let parameters = {
        serviceUuid: this.serviceId,
        serviceDeliveryTypeUuid: this.deliveryTypeId,
        request: {
          deliveryFrequencyKbn: this.inpDeliveryFrequency,
          deliveryToKbn: this.inpDeliveryTarget,
          deliveryPeriodDays: this.inpDeliveryTerm,
          deliveryEndTime: this.inpDeliveryEndHour + ':' + this.inpDeliveryEndMinute
        }
      }
      if (this.inpDeliveryStartHour !== '' &&
        this.inpDeliveryStartMinute !== '') {
        parameters.request.deliveryStartTime = this.inpDeliveryStartHour + ':' + this.inpDeliveryStartMinute
      }
      if (this.isModify) {
        parameters.serviceDeliveryPeriodUuid = this.modifyTargetId
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['serviceDeliveryType'],
        [this.isRegister ?
          'v1ServiceDeliveryTypeSettingPost' :
          'v1ServiceDeliveryTypeSettingPut'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: this.isRegister ?
                '新しい' + this.categoryName + 'の登録' :
                this.categoryName + '情報の変更',
              body: this.isRegister ?
                this.categoryName + 'を登録しました。' :
                this.categoryName + 'を変更しました。'
            })

            // this.modifyTargetId = null

            // 一覧データを再読出し
            this.init()
            this.registerItem()

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },
    deleteData () {
      this.processing = true

      //
      let parameters = {
        serviceUuid: this.serviceId,
        serviceDeliveryTypeUuid: this.deliveryTypeId,
        serviceDeliveryPeriodUuid: this.deleteTargetId
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['serviceDeliveryType'],
        ['v1ServiceDeliveryTypeSettingDelete'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: this.categoryName + '情報の削除',
              body: this.categoryName + 'を削除しました。'
            })

            this.deleteTargetId = null

            // 一覧データを再読出し
            this.init()

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },

    // 登録済み一覧
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      switch (key) {
        case 'deliveryFrequencyKbn':
          return Utility.getConstantsLabel(['Service', 'DeleiveryFrequency'], value)
        case 'deliveryToKbn':
          return Utility.getConstantsLabel(['Service', 'DeliveryTarget'], value)
        case 'deliveryPeriodDays':
          return value + '日間'
        case 'deliveryStartTime':
          return value || Constants.BlankValue
      }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    // 絞り込み
    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    registerItem () {
      this.initRegister()
    },
    modifyItem (props) {
      this.modifyTargetId = props.row.serviceDeliveryPeriodUUid
      this.initModify({
        data: props.row
      })
    },
    deleteItem (props) {
      this.deleteTargetId = props.row.serviceDeliveryPeriodUUid
      // confirm
      const id = Utility.getObjectArrayValue(this.deliveryPeriodModel, 'serviceDeliveryPeriodUUid', this.deleteTargetId, 'serviceDeliveryPeriodId')
      this.showConfirm({
        key: 'delete',
        title: '',
        body: '「Id : ' + id + '」の' + this.categoryName + 'を削除しますか？',
        acceptLabel: '削除'
      })
    }
  }
}